import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as SimeraDark } from '$icons/simera-dark logo.svg';
import AccountButton from '../AccountButton/AccountButton';
import classes from './SimeraDashboardLayout.module.css';
import DropdownMenu from '../DropdownMenu/DropdownMenu';
import AddNewPositionButton from '../EmployerDashboard/AddNewPositionButton';
import InternalDashboardPages from '../../constants/InternalDashboardPages';
import SimeraNavTab from './SimeraNavTab/SimeraNavTab';
import {
  SIMERA_CANDIDATES_ROUTE,
  SIMERA_EMPLOYERS_ROUTE,
  SIMERA_POSITIONS_ROUTE,
  SIMERA_JOB_INTERVIEWS_ROUTE,
  SIMERA_SEARCH_CANDIDATES,
  SIMERA_SMART_INTERVIEWS,
  SIMERA_CLIENT_ROUTE,
} from '../../constants/routes';

interface LayoutProps {
  children?: React.ReactNode;
  activeTab: InternalDashboardPages;
}

const SimeraDashboardLayout: FC<LayoutProps> = ({ children, activeTab }) => {
  const [openMenu, setOpenMenu] = useState(false);
  const { t } = useTranslation('global');

  return (
    <div data-testid="home-container" className={classes.Container}>
      {openMenu && (
        <DropdownMenu
          className={classes.DropdownMenu}
          isInternal
          setModal={setOpenMenu}
        />
      )}
      <div className={classes.Nav}>
        <div className="relative">
          <div className={`${classes.Logo} mr-4`}>
            <SimeraDark />
          </div>
          <p className="text-internal-main text-sm absolute -right-0 -bottom-3">
            {t('SimeraInternal.Admin')}
          </p>
        </div>
        <div className="flex flex-row gap-4 md:gap-8 flex-1 items-center flex-wrap">
          <SimeraNavTab
            isActive={activeTab === InternalDashboardPages.POSITIONS}
            route={SIMERA_POSITIONS_ROUTE}
            text={t('SimeraInternal.Positions')}
          />
          <SimeraNavTab
            isActive={activeTab === InternalDashboardPages.CANDIDATES}
            route={SIMERA_CANDIDATES_ROUTE}
            text={t('SimeraInternal.CandidatesTitle')}
          />
          <SimeraNavTab
            isActive={activeTab === InternalDashboardPages.COMPANIES}
            route={SIMERA_CLIENT_ROUTE}
            text={t('SimeraInternal.ClientTitle')}
          />
          <SimeraNavTab
            isActive={activeTab === InternalDashboardPages.EMPLOYERS}
            route={SIMERA_EMPLOYERS_ROUTE}
            text={t('SimeraInternal.UsersTitle')}
          />
          <SimeraNavTab
            isActive={activeTab === InternalDashboardPages.JOBINTERVIEW}
            route={SIMERA_JOB_INTERVIEWS_ROUTE}
            text={t('SimeraInternal.InterviewsTitle')}
          />
          <SimeraNavTab
            isActive={activeTab === InternalDashboardPages.SEARCH_CANDIDATES}
            route={SIMERA_SEARCH_CANDIDATES}
            text={t('SimeraInternal.SearchCandidates')}
          />
          <SimeraNavTab
            isActive={activeTab === InternalDashboardPages.SMART_INTERVIEWS}
            route={SIMERA_SMART_INTERVIEWS}
            text="Smart Interviews"
          />
        </div>
        <div className={classes.Account}>
          {activeTab === InternalDashboardPages.POSITIONS && (
            <AddNewPositionButton />
          )}
          <AccountButton
            isProfile
            t={t}
            action={() => setOpenMenu(!openMenu)}
          />
        </div>
      </div>
      {children && <div className={classes.Content}>{children}</div>}
    </div>
  );
};

SimeraDashboardLayout.defaultProps = {
  children: null,
};

export default SimeraDashboardLayout;
